import React from 'react';
import { formatNumber } from './chartUtils';

export interface KpiCardItem {
  key: string;
  label: string;
  value: number | string;
  subtitle?: string;
  variant?: 'default' | 'overdue' | 'critical-subtitle';
  clickable?: boolean;
  active?: boolean;
  onClick?: () => void;
}

interface KpiCardGridProps {
  items: KpiCardItem[];
  layout: 'statewide' | 'operational';
}

export default function KpiCardGrid({ items, layout }: Readonly<KpiCardGridProps>) {
  const gridClass =
    layout === 'statewide'
      ? 'analytics-kpi-grid analytics-kpi-grid--statewide'
      : 'analytics-kpi-grid analytics-kpi-grid--operational';

  return (
    <div className={gridClass}>
      {items.map(item => {
        const valueClass =
          item.variant === 'overdue'
            ? 'analytics-kpi-value analytics-kpi-value--overdue'
            : 'analytics-kpi-value';
        const subtitleClass =
          item.variant === 'critical-subtitle'
            ? 'analytics-kpi-subtitle analytics-kpi-subtitle--critical'
            : 'analytics-kpi-subtitle';
        const cardClass = [
          'analytics-kpi-card',
          item.clickable ? 'analytics-kpi-card--clickable' : '',
          item.active ? 'analytics-kpi-card--active' : '',
          item.variant === 'overdue' && item.active ? 'analytics-kpi-card--overdue-active' : '',
        ]
          .filter(Boolean)
          .join(' ');

        const displayValue = typeof item.value === 'number' ? formatNumber(item.value) : item.value;

        return (
          <div
            key={item.key}
            className={cardClass}
            role={item.clickable ? 'button' : undefined}
            tabIndex={item.clickable ? 0 : undefined}
            onClick={item.onClick}
            onKeyDown={
              item.clickable
                ? e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      item.onClick?.();
                    }
                  }
                : undefined
            }
          >
            <p className="analytics-kpi-label">{item.label}</p>
            <p className={valueClass}>{displayValue}</p>
            {item.subtitle ? <p className={subtitleClass}>{item.subtitle}</p> : null}
          </div>
        );
      })}
    </div>
  );
}
